import { CellComponentProps } from './types';

// Default components
export const DefaultCell = <T,>({ value }: CellComponentProps<T>) => (
  <div className="px-3 py-2 truncate">{value}</div>
);

export const CellRenderer = <T,>({
  value,
  column,
  ...props
}: CellComponentProps<T>) => {
  return <DefaultCell column={column} {...props} value={value} />;
};
